import { ApiService } from 'services';
import { handleException } from 'actions/exceptions';

export const VERIFY_PIN_SUCCESS = 'VERIFY_PIN_SUCCESS';
export const VERIFY_PIN_REQUEST = 'VERIFY_PIN_REQUEST';
export const VERIFY_PIN_ERROR = 'VERIFY_PIN_ERROR';

export const REQUEST_PIN = 'REQUEST_PIN';
export const REQUEST_PIN_ERROR = 'REQUEST_PIN_ERROR';
export const REQUEST_PIN_SUCCESS = 'REQUEST_PIN_SUCCESS';

export const SHOW_PIN_VERIFICATION = 'SHOW_PIN_VERIFICATION';
export const HIDE_PIN_VERIFICATION = 'HIDE_PIN_VERIFICATION';

export const REQUEST_PIN_CONFIRMATION = 'REQUEST_PIN_CONFIRMATION';
export const REQUEST_PIN_CONFIRMATION_SUCCESS = 'REQUEST_PIN_CONFIRMATION_SUCCESS';
export const REQUEST_PIN_CONFIRMATION_ERROR = 'REQUEST_PIN_CONFIRMATION_ERROR';

function requestPinVerification() {
  return {
    type: VERIFY_PIN_REQUEST,
  };
}

function receivePinVerification() {
  return {
    type: VERIFY_PIN_SUCCESS,
  };
}

function rejectPinVerification(error) {
  return {
    type: VERIFY_PIN_ERROR,
    code: error.code,
    message: error.message
  };
}

function rejectPinRequest(error) {
  return {
    type: REQUEST_PIN_ERROR,
    code: error.code,
    message: error.message
  };
}

function requestPin() {
  return {
    type: REQUEST_PIN
  };
}

function recievePin(data) {
  return {
    type: REQUEST_PIN_SUCCESS,
    message: data.Data
  };
}

function showPinVerificationModal() {
  return {
    type: SHOW_PIN_VERIFICATION,
  };
}

function requestPinConfirmation() {
  return {
    type: REQUEST_PIN_CONFIRMATION,
  };
}

function recievePinConfirmation(data) {
  return {
    type: REQUEST_PIN_CONFIRMATION_SUCCESS,
    message: data.Data
  };
}

function rejectPinConfirmation(error) {
  return {
    type: REQUEST_PIN_CONFIRMATION_ERROR,
    code: error.code,
    message: error.message
  };
}

export function sendPinConfirmation(pinType, resendReference) {
  return (dispatch) => {
    dispatch(requestPinConfirmation());
    const promise = () => ApiService
      .sendPinConfirmation(pinType, resendReference)
      .then((response) => {
        dispatch(recievePinConfirmation(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectPinConfirmation, true, false));
        }
      });

    return promise();
  };
}

export function hidePinVerificationModal() {
  return {
    type: HIDE_PIN_VERIFICATION,
  };
}

export function sendVerificationPin(pinType) {
  return (dispatch) => {
    dispatch(requestPin());
    dispatch(showPinVerificationModal());
    const promise = () => ApiService
      .sendPinToRecipient(pinType)
      .then((response) => {
        dispatch(recievePin(response.data));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectPinRequest, true, false));
        }
      });

    return promise();
  };
}

// TODO: Add api call here + add request/reject action methods
export function authenticatePin(pin, pinType) {
  return (dispatch) => {
    dispatch(requestPinVerification());
    const promise = () => ApiService
      .validatePin(pin, pinType)
      .then((response) => {
        dispatch(receivePinVerification());
        dispatch(hidePinVerificationModal());
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }

        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectPinVerification, false, false));
        }
      });

    return promise();
  };
}
